import { GmcApi } from '../../constants/gmc-api';
import { IHttpParamSerializer, IHttpService, IPromise } from 'angular';
import { groupBy } from 'lodash-es';
import {
  IIncomingCVGroupByDate,
  IncomingCv
} from '../../../states/top-cv/shared/incoming-cv';
import * as moment from 'moment';

export class TopCvService {
  static $inject = ['$http', 'GmcApi', '$httpParamSerializer'];

  constructor(private $http: IHttpService, private gmcApi: GmcApi, private $httpParamSerializer: IHttpParamSerializer) {}

  getIncomingCv(params: object = {}): IPromise<any> {
    return this.$http
      .post<any>(
        `${this.gmcApi.cv.incomingCV}`,
        this.$httpParamSerializer(params) ,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      .then((res) => {
        console.log(res);
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  getIncomeCv(params: { id: string }): IPromise<any> {
    return this.$http
      .get<any>(`${this.gmcApi.cv.incomeCV}`, { params })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  deleteCv(id) {
    return this.$http
      .delete<any>(`${this.gmcApi.cv.deleteCv}/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  deleteAllCv(params: object = {}) {
    return this.$http
      .delete<any>(`${this.gmcApi.cv.incomingCV}/all`, { params })
      .then((res) => {
        console.log(res);
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  groupCVsByDate(CVs: IncomingCv[]): IIncomingCVGroupByDate[] {
    const groupDateMap = groupBy(CVs, (cv) => {
      return moment(cv.date)
        .startOf('day')
        .toISOString();
    });
    return Object.keys(groupDateMap).map((date) => {
      return {
        date: moment(date),
        CVs: groupDateMap[date]
      };
    });
  }
}



// WEBPACK FOOTER //
// ./app/core/services/cv/cv.service.ts